import {Link as MuiLink, Paper as MuiPaper, Stack, styled, Typography} from "@mui/material";

const Link = styled(MuiLink)(() => ({
    textDecoration: 'none',
}));

const Paper = styled(MuiPaper)(({theme}) => ({
    borderWidth: 2,
    [theme.breakpoints.up('xs')]: {
        padding: '0.5rem 0.5rem 1rem 0.5rem',
    },
    [theme.breakpoints.up('md')]: {
        padding: '1rem',
        height: "100%",
        minHeight: '380px',
    }
}));

const Title = styled(MuiPaper)(({theme}) => ({
    [theme.breakpoints.up('xs')]: {
        padding: '0.5rem',
    },
    [theme.breakpoints.up('md')]: {
        padding: '1rem',
        height: "100%",
    }
}));

const Arrow = styled(Typography)(() => ({
    lineHeight: 0.45,
}));

export const CardOutline = ({title, color, showArrow = false, children}) => {
    return (
        <Paper variant="outlined" sx={{borderColor: `${color}.main`}}>
            <Stack spacing={2} sx={{height: '100%', justifyContent: 'space-between', flexGrow: 1}}>
                <Stack spacing={2} size="grow">
                    <CardTitle title={title} color={color}/>
                    {children}
                </Stack>
                {showArrow && <Arrow variant="h1" sx={{color: `${color}.main`}}>→</Arrow>}
            </Stack>
        </Paper>
    );
};

const CardTitle = ({title, color}) => {
    return (
        <Title elevation={0} sx={{backgroundColor: `${color}.main`, color: `${color}.contrastText`}}>
            <Typography variant="h6">{title}</Typography>
        </Title>
    );
};

export const ProductCard = ({title, color, children}) => {
    return (
        <CardOutline title={title} color={color}>
            {children}
        </CardOutline>
    );
};

export const ProductCardWithLink = ({id, link, title, color, children}) => {
    return (
        <Link id={id} name={id} href={link}>
            <CardOutline title={title} color={color} showArrow={true}>
                {children}
            </CardOutline>
        </Link>
    );
};
